(function () {
  'use strict';

  var STORAGE_KEY = 'shopify_wishlist';
  var CACHE_KEY = 'shopify_wishlist_products';
  var CUSTOMER_TOKEN_KEY = 'shopify_wishlist_customer_account_token';
  var CUSTOMER_TOKEN_EXPIRY_KEY = 'shopify_wishlist_customer_account_token_expires';
  var CUSTOMER_PKCE_KEY = 'shopify_wishlist_customer_account_pkce';
  var PENDING_CLASSIC_LOGIN_KEY = 'shopify_wishlist_pending_classic_login';
  var WISHLIST_AUTH_FORM_KEY = 'shopify_wishlist_auth_form';
  var METADATA_KEY = 'shopify_wishlist_metadata';
  var CONFIG_ID = 'omx-wishlist-config';

  var state = {
    ids: [],
    products: {},
    config: {},
    cartVariantIds: {},
    isOpen: false,
    isLoginOpen: false,
    customerId: '',
    customerSyncReady: false,
    syncInFlight: false
  };

  function readConfig() {
    var node = document.getElementById(CONFIG_ID);
    if (!node) return {};

    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      console.warn('[Wishlist] Invalid config JSON', error);
      return {};
    }
  }

  function normalizeId(id) {
    return String(id || '').replace('gid://shopify/Product/', '').trim();
  }

  function unique(ids) {
    return Array.from(new Set((ids || []).map(normalizeId).filter(Boolean)));
  }

  function readJson(key, fallback) {
    try {
      var value = window.localStorage.getItem(key);
      return value ? JSON.parse(value) : fallback;
    } catch (error) {
      return fallback;
    }
  }

  function writeJson(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.warn('[Wishlist] localStorage write failed', error);
    }
  }

  function removeStorage(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      console.warn('[Wishlist] localStorage remove failed', error);
    }
  }

  function readSessionJson(key, fallback) {
    try {
      var value = window.sessionStorage.getItem(key);
      return value ? JSON.parse(value) : fallback;
    } catch (error) {
      return fallback;
    }
  }

  function writeSessionJson(key, value) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.warn('[Wishlist] sessionStorage write failed', error);
    }
  }

  function readSession(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeSession(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      console.warn('[Wishlist] sessionStorage write failed', error);
    }
  }

  function removeSession(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {
      console.warn('[Wishlist] sessionStorage remove failed', error);
    }
  }

  function readMetadata() {
    return readJson(METADATA_KEY, {});
  }

  function setItemMetadata(productId, data) {
    var meta = readMetadata();
    var id = normalizeId(productId);
    if (!meta[id]) {
      meta[id] = Object.assign({}, data);
      writeJson(METADATA_KEY, meta);
    }
  }

  function getItemMetadata(productId) {
    var meta = readMetadata();
    return meta[normalizeId(productId)] || {};
  }

  function readCustomerToken() {
    var token = '';
    var expiresAt = 0;

    try {
      token = window.localStorage.getItem(CUSTOMER_TOKEN_KEY) || '';
      expiresAt = Number(window.localStorage.getItem(CUSTOMER_TOKEN_EXPIRY_KEY) || 0);
    } catch (error) {
      return '';
    }

    if (!token || (expiresAt && Date.now() > expiresAt)) {
      clearCustomerToken();
      return '';
    }

    return token;
  }

  function writeCustomerToken(token, expiresIn) {
    if (!token) return;

    try {
      window.localStorage.setItem(CUSTOMER_TOKEN_KEY, token);
      if (expiresIn) {
        window.localStorage.setItem(CUSTOMER_TOKEN_EXPIRY_KEY, String(Date.now() + Number(expiresIn) * 1000 - 60000));
      }
    } catch (error) {
      console.warn('[Wishlist] Customer token write failed', error);
    }
  }

  function clearCustomerToken() {
    removeStorage(CUSTOMER_TOKEN_KEY);
    removeStorage(CUSTOMER_TOKEN_EXPIRY_KEY);
  }

  function parseProductAttribute(button) {
    var raw = button && button.getAttribute('data-omx-product');
    if (!raw) return null;

    try {
      return normalizeProduct(JSON.parse(raw));
    } catch (error) {
      console.warn('[Wishlist] Invalid product payload', error);
      return null;
    }
  }

  function getExcludeWishlistCollectionHandles() {
    var h = state.config && state.config.excludeFromWishlistCollectionHandles;
    return Array.isArray(h) ? h : [];
  }

  function productExcludedFromWishlist(product) {
    return !!(product && product.excludedFromWishlist === true);
  }

  function stripExcludedWishlistProducts() {
    var before = state.ids.join(',');
    state.ids = state.ids.filter(function (id) {
      var p = state.products[id];
      if (!p) return true;
      return !productExcludedFromWishlist(p);
    });
    Object.keys(state.products).forEach(function (id) {
      var p = state.products[id];
      if (p && productExcludedFromWishlist(p)) delete state.products[id];
    });
    if (state.ids.join(',') !== before) {
      persist();
      render();
      saveRemoteWishlist();
    }
  }

  function normalizeProduct(product) {
    if (!product || !product.id) return null;

    var normalized = Object.assign({}, product);
    normalized.id = normalizeId(normalized.id);
    normalized.variantId = normalized.variantId ? String(normalized.variantId).replace('gid://shopify/ProductVariant/', '') : '';
    normalized.available = normalized.available !== false;
    normalized.variantTitle = normalized.variantTitle === 'Default Title' ? '' : normalized.variantTitle;
    normalized.collectionHandles = Array.isArray(normalized.collectionHandles) ? normalized.collectionHandles : [];
    normalized.omxWishlistCollectionsFromApi = normalized.omxWishlistCollectionsFromApi === true;

    var ex = getExcludeWishlistCollectionHandles();
    if (normalized.excludedFromWishlist === true) {
      /* Liquid / Kunden-Metafeld */
    } else if (ex.length && normalized.collectionHandles.some(function (h) { return ex.indexOf(h) !== -1; })) {
      normalized.excludedFromWishlist = true;
    } else {
      normalized.excludedFromWishlist = false;
    }

    return normalized;
  }

  function normalizeVariantIdForCart(id) {
    if (id == null || id === '') return '';
    return String(id).replace('gid://shopify/ProductVariant/', '').trim();
  }

  function applyCartItemsFromPayload(cart) {
    var next = {};
    if (cart && cart.items && cart.items.length) {
      cart.items.forEach(function (line) {
        var vid = normalizeVariantIdForCart(line.variant_id);
        if (vid) next[vid] = true;
      });
    }
    state.cartVariantIds = next;
  }

  function isVariantInCart(variantId) {
    var key = normalizeVariantIdForCart(variantId);
    return !!key && state.cartVariantIds[key] === true;
  }

  function syncCartVariantIdsFromNetwork() {
    if (!window.routes || !window.routes.cart_url) {
      return Promise.resolve();
    }
    return fetch(window.routes.cart_url + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        applyCartItemsFromPayload(cart);
      })
      .catch(function () {
        state.cartVariantIds = {};
      });
  }

  function hydrateFromDom() {
    document.querySelectorAll('[data-omx-wishlist-button]').forEach(function (button) {
      var product = parseProductAttribute(button);
      if (product) state.products[product.id] = product;
    });
  }

  function loadState() {
    state.config = readConfig();

    var localIds = unique(readJson(STORAGE_KEY, []));
    var configIds = unique(state.config.initialProductIds || []);
    var cachedProducts = readJson(CACHE_KEY, {});
    var configProducts = {};

    (state.config.initialProducts || []).forEach(function (product) {
      product = normalizeProduct(product);
      if (product) configProducts[product.id] = product;
    });

    state.ids = unique(configIds.concat(localIds));
    state.products = Object.assign({}, cachedProducts, configProducts);

    hydrateFromDom();
    Object.keys(state.products).forEach(function (id) {
      var p = normalizeProduct(state.products[id]);
      if (p) state.products[id] = p;
      else delete state.products[id];
    });
    stripExcludedWishlistProducts();
    persist();
  }

  function persist() {
    writeJson(STORAGE_KEY, state.ids);
    writeJson(CACHE_KEY, state.products);
  }

  function isSaved(productId) {
    return state.ids.indexOf(normalizeId(productId)) !== -1;
  }

  function add(product) {
    product = normalizeProduct(product);
    if (!product || productExcludedFromWishlist(product)) return;

    if (!isSaved(product.id)) {
      state.ids.push(product.id);
      setItemMetadata(product.id, {
        added_at: new Date().toISOString(),
        price_at_add: product.price || null
      });
    }

    state.products[product.id] = product;
    persist();
    render();
    fetchMissingProducts();
    saveRemoteWishlist();
  }

  function remove(productId) {
    productId = normalizeId(productId);
    state.ids = state.ids.filter(function (id) {
      return id !== productId;
    });
    persist();
    render();
    saveRemoteWishlist();
  }

  function clearEntireWishlist() {
    state.ids = [];
    state.products = {};
    persist();
    render();
    saveRemoteWishlist();
    announce('Wishlist wurde geleert');
  }

  function toggle(button) {
    var product = parseProductAttribute(button);
    if (!product) return;

    if (isSaved(product.id)) {
      remove(product.id);
      announce('Von der Wishlist entfernt');
    } else {
      add(product);
      button.classList.remove('omx-is-pulsing');
      void button.offsetWidth;
      button.classList.add('omx-is-pulsing');
      announce('Zur Wishlist hinzugefügt');
    }
  }

  function announce(message) {
    var live = document.querySelector('[data-omx-wishlist-live]');
    if (live) live.textContent = message;
  }

  function renderButtons() {
    document.querySelectorAll('[data-omx-wishlist-button]').forEach(function (button) {
      var productId = normalizeId(button.getAttribute('data-product-id'));
      var saved = isSaved(productId);
      var addText = button.getAttribute('data-add-text') || 'Zur Wishlist';
      var removeText = button.getAttribute('data-remove-text') || 'Von Wishlist entfernen';
      var label = saved ? removeText : addText;

      button.classList.toggle('is-active', saved);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      button.setAttribute('aria-label', label);

      var text = button.querySelector('[data-omx-wishlist-text]');
      if (text) text.textContent = label;
    });
  }

  function renderHeaderCount() {
    document.querySelectorAll('[data-omx-wishlist-count]').forEach(function (badge) {
      badge.textContent = state.ids.length;
      badge.hidden = state.ids.length === 0;
    });
  }

  function syncWishlistDrawerCartIconFromHeader() {
    var main = document.getElementById('cart-icon-bubble');
    var mirror = document.querySelector('[data-omx-wishlist-drawer-cart]');
    if (!main || !mirror) return;
    mirror.innerHTML = main.innerHTML;
  }

  function observeHeaderCartBubbleForWishlistDrawer() {
    var main = document.getElementById('cart-icon-bubble');
    var mirror = document.querySelector('[data-omx-wishlist-drawer-cart]');
    if (!main || !mirror || main.dataset.omxWishlistCartMirror === '1') return;
    main.dataset.omxWishlistCartMirror = '1';
    var sync = function () {
      mirror.innerHTML = main.innerHTML;
    };
    try {
      new MutationObserver(sync).observe(main, { childList: true, subtree: true });
    } catch (e) {
      /* no-op */
    }
  }

  function money(value) {
    if (value == null || value === '') return '';
    if (typeof value === 'string' && value.indexOf('<') !== -1) return value;
    return String(value).replace(/\s+[A-Z]{3}$/, '');
  }

  function wishlistCartActionHtml(product, layout) {
    layout = layout || 'drawer';
    var inCartClass =
      layout === 'card' ? 'omx-wishlist-card__in-cart' : 'omx-wishlist-drawer__in-cart';

    if (!product.variantId || !product.available) {
      return (
        '<a class="button button--secondary ' +
        (layout === 'card' ? '' : 'omx-wishlist-drawer__cart') +
        '" href="' +
        escapeHtml(product.url || '#') +
        '">Ansehen</a>'
      );
    }

    if (isVariantInCart(product.variantId)) {
      return (
        '<span class="' +
        inCartClass +
        '" role="status" aria-live="polite">Bereits im Warenkorb</span>'
      );
    }

    var btnClass =
      layout === 'card'
        ? 'button button--primary'
        : 'button button--primary omx-wishlist-drawer__cart';
    return (
      '<button type="button" class="' +
      btnClass +
      '" data-omx-wishlist-cart="' +
      escapeHtml(product.variantId) +
      '">In den Warenkorb</button>'
    );
  }

  function productRow(product) {
    if (!product) return '';

    var image = product.image
      ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title || '') + '" loading="lazy" width="80" height="80">'
      : '<div class="omx-wishlist-drawer__placeholder" aria-hidden="true"></div>';
    var variant = product.variantTitle ? '<p class="omx-wishlist-drawer__variant">' + escapeHtml(product.variantTitle) + '</p>' : '';
    var cartButton = wishlistCartActionHtml(product, 'drawer');
    var removeIcon = '<span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-remove" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path fill="currentColor" d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1M6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02m4.84 11.52h-7.5V4h7.5z"/><path fill="currentColor" d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5"/></svg></span>';

    return [
      '<article class="omx-wishlist-drawer__item" data-product-id="' + escapeHtml(product.id) + '">',
      '<a class="omx-wishlist-drawer__image" href="' + escapeHtml(product.url || '#') + '">' + image + '</a>',
      '<div class="omx-wishlist-drawer__content">',
      '<a class="omx-wishlist-drawer__product-title" href="' + escapeHtml(product.url || '#') + '">' + escapeHtml(product.title || 'Produkt') + '</a>',
      variant,
      '</div>',
      '<div class="omx-wishlist-drawer__price">' + money(product.price) + '</div>',
      '<div class="omx-wishlist-drawer__actions">' + cartButton + '<button type="button" class="button button--tertiary omx-wishlist-drawer__remove" data-omx-wishlist-remove="' + escapeHtml(product.id) + '" aria-label="Aus Wishlist entfernen">' + removeIcon + '</button></div>',
      '</article>'
    ].join('');
  }

  function isWishlistMobileStackBreakpoint() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  /**
   * Mirrors cart-drawer.js showMobileOverlay: inline !important so stacking beats theme/CSS quirks.
   * Mobile: dim fullscreen layer z-1000, panel z-998, login drawer z-1001 (CSS).
   */
  function syncWishlistLoginLayer() {
    var root = document.querySelector('[data-omx-wishlist-drawer]');
    if (!root) return;

    var stack = root.querySelector('[data-omx-wishlist-login-stack-overlay]');
    var panel = root.querySelector('.omx-wishlist-drawer__panel');
    var backdrop = root.querySelector('[data-omx-wishlist-panel-backdrop]');

    var mobile = isWishlistMobileStackBreakpoint();
    var loginLayer = state.isOpen && state.isLoginOpen;
    var stackActive = !!(stack && mobile && loginLayer);

    if (stack) {
      if (stackActive) {
        stack.style.cssText = [
          'position:fixed!important',
          'top:0!important',
          'left:0!important',
          'right:0!important',
          'bottom:0!important',
          'width:100vw!important',
          'height:100vh!important',
          'min-height:100dvh!important',
          'background:rgba(0,0,0,0.7)!important',
          'z-index:1000!important',
          'opacity:1!important',
          'visibility:visible!important',
          'pointer-events:auto!important',
          'display:block!important'
        ].join(';');
      } else {
        stack.removeAttribute('style');
      }
    }

    if (panel) {
      if (stackActive) {
        panel.style.setProperty('z-index', '998', 'important');
      } else {
        panel.style.removeProperty('z-index');
      }
    }

    if (backdrop) {
      if (stackActive) {
        backdrop.style.cssText = 'display:none!important;';
      } else if (loginLayer && !mobile) {
        backdrop.style.cssText = 'opacity:1!important;pointer-events:auto!important;';
      } else {
        backdrop.removeAttribute('style');
      }
    }
  }

  function renderDrawer() {
    var drawer = document.querySelector('[data-omx-wishlist-drawer]');
    if (!drawer) return;

    var list = drawer.querySelector('[data-omx-wishlist-list]');
    var empty = drawer.querySelector('[data-omx-wishlist-empty]');
    var items = state.ids.map(function (id) {
      return state.products[id];
    }).filter(Boolean);

    if (list) list.innerHTML = items.map(productRow).join('');
    if (empty) empty.hidden = state.ids.length !== 0;
    drawer.classList.toggle('is-open', state.isOpen);
    drawer.classList.toggle('is-login-open', state.isLoginOpen);
    drawer.setAttribute('aria-hidden', state.isOpen ? 'false' : 'true');
    var loginDrawer = drawer.querySelector('[data-omx-wishlist-login-drawer]');
    if (loginDrawer) {
      loginDrawer.classList.toggle('is-open', state.isOpen && state.isLoginOpen);
      loginDrawer.setAttribute('aria-hidden', state.isOpen && state.isLoginOpen ? 'false' : 'true');
    }
    document.documentElement.classList.toggle('omx-wishlist-open', state.isOpen);
    syncWishlistLoginLayer();
  }

  function renderPage() {
    var page = document.querySelector('[data-omx-wishlist-page]');
    if (!page) return;

    var grid = page.querySelector('[data-omx-wishlist-page-grid]');
    var empty = page.querySelector('[data-omx-wishlist-page-empty]');
    var guest = page.querySelector('[data-omx-wishlist-guest]');
    var items = state.ids.map(function (id) {
      return state.products[id];
    }).filter(Boolean);

    if (grid) {
      grid.innerHTML = items.map(function (product) {
        return [
          '<article class="omx-wishlist-card" data-product-id="' + escapeHtml(product.id) + '">',
          '<a class="omx-wishlist-card__image" href="' + escapeHtml(product.url || '#') + '">',
          product.image ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title || '') + '" loading="lazy">' : '<span aria-hidden="true"></span>',
          '</a>',
          '<div class="omx-wishlist-card__body">',
          '<h2 class="omx-wishlist-card__title"><a href="' + escapeHtml(product.url || '#') + '">' + escapeHtml(product.title || 'Produkt') + '</a></h2>',
          product.variantTitle ? '<p class="omx-wishlist-card__variant">' + escapeHtml(product.variantTitle) + '</p>' : '',
          '<p class="omx-wishlist-card__price">' + money(product.price) + '</p>',
          wishlistCartActionHtml(product, 'card'),
          '<button type="button" class="button button--secondary omx-wishlist-card__remove" data-omx-wishlist-remove="' + escapeHtml(product.id) + '">Von Wishlist entfernen</button>',
          '</div>',
          '</article>'
        ].join('');
      }).join('');
    }

    if (empty) empty.hidden = state.ids.length !== 0;
    if (guest) guest.hidden = !!state.config.customerLoggedIn || !!readCustomerToken();
  }

  function render() {
    renderButtons();
    renderHeaderCount();
    renderDrawer();
    renderPage();
    updateBulkAddAllButtons();
    updateCartDrawerWishlistButton();
  }

  function openDrawer() {
    state.isOpen = true;
    state.isLoginOpen = false;
    renderDrawer();

    syncCartVariantIdsFromNetwork().finally(function () {
      render();
    });

    var drawer = document.querySelector('[data-omx-wishlist-drawer]');
    var close = drawer && drawer.querySelector('[data-omx-wishlist-close]');
    if (close) close.focus();
  }

  function closeDrawer() {
    state.isOpen = false;
    state.isLoginOpen = false;
    hideDrawerNotice();
    renderDrawer();
  }

  function openLoginDrawer() {
    state.isOpen = true;
    state.isLoginOpen = true;
    renderDrawer();

    var drawer = document.querySelector('[data-omx-wishlist-login-drawer]');
    var input = drawer && drawer.querySelector('input[type="email"]');
    if (input) input.focus();
  }

  function closeLoginDrawer() {
    state.isLoginOpen = false;
    renderDrawer();
  }

  function renderWishlistAuthErrors() {
    var submittedForm = readSession(WISHLIST_AUTH_FORM_KEY);
    if (!submittedForm) return;

    var errors = document.querySelectorAll('[data-omx-wishlist-auth-error]');
    if (!errors.length) {
      removeSession(WISHLIST_AUTH_FORM_KEY);
      return;
    }

    document.querySelectorAll('[data-omx-wishlist-auth-panel]').forEach(function (panel) {
      panel.open = panel.getAttribute('data-omx-wishlist-auth-panel') === submittedForm;
    });

    errors.forEach(function (error) {
      error.hidden = error.getAttribute('data-omx-wishlist-auth-error') !== submittedForm;
    });
  }

  function showDrawerNotice(message) {
    var notice = document.querySelector('[data-omx-wishlist-notice]');
    if (!notice) return;

    notice.textContent = message;
    notice.hidden = false;
  }

  function hideDrawerNotice() {
    var notice = document.querySelector('[data-omx-wishlist-notice]');
    if (!notice) return;

    notice.textContent = '';
    notice.hidden = true;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function addToCart(variantId) {
    if (!variantId) return Promise.resolve();

    /* Prefer cart drawer (same as product-form.js); else cart-notification; else full cart page. */
    var cart =
      document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    if (cart && typeof cart.getSectionsToRender === 'function' && typeof cart.renderContents === 'function') {
      var formData = new FormData();
      formData.append('id', String(variantId));
      formData.append('quantity', '1');
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      formData.append('sections_url', window.location.pathname);

      return fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript'
        },
        body: formData
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response.status) {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'wishlist',
                productVariantId: String(variantId),
                errors: response.errors || response.description,
                message: response.message
              });
            }
            console.warn('[Wishlist] Cart add error', response.description || response.message);
            return;
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'wishlist',
              productVariantId: String(variantId),
              cartData: response
            });
          }

          if (typeof cart.setActiveElement === 'function') {
            cart.setActiveElement(document.activeElement);
          }
          cart.renderContents(response);
          if (cart.classList && cart.classList.contains('is-empty')) {
            cart.classList.remove('is-empty');
          }
          function finishWishlistAfterCartAdd() {
            render();
            /* Wishlist comes after <cart-drawer> in DOM with same z-index — close so the drawer is visible. */
            closeDrawer();
          }

          if (response.items) {
            applyCartItemsFromPayload(response);
            finishWishlistAfterCartAdd();
          } else {
            syncCartVariantIdsFromNetwork().finally(finishWishlistAfterCartAdd);
          }
        })
        .catch(function (error) {
          console.warn('[Wishlist] Cart add failed', error);
        });
    }

    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart add failed');
        return response.json();
      })
      .then(function () {
        window.location.href = window.routes.cart_url;
      })
      .catch(function (error) {
        console.warn('[Wishlist] Cart add failed', error);
      });
  }

  function getWishlistProductRows() {
    return state.ids
      .map(function (id) {
        return state.products[id];
      })
      .filter(Boolean);
  }

  function hasAvailableWishlistItems() {
    if (!state.ids.length) return false;
    if (getBulkAddCartItems().length > 0) return true;
    var rows = getWishlistProductRows();
    /* Noch nicht alle Produkte geladen: Button kurz zeigen, bis klar ist ob etwas hinzufügbar ist */
    return rows.length < state.ids.length;
  }

  function updateCartDrawerWishlistButton() {
    var cartDrawer = document.querySelector('cart-drawer');
    var isEmpty = !!(cartDrawer && cartDrawer.classList.contains('is-empty'));
    var nodes = document.querySelectorAll('[data-omx-cart-wishlist-link]');
    if (!nodes.length) return;
    var show = hasAvailableWishlistItems();
    nodes.forEach(function (btn) {
      var inEmptyOnly = btn.classList.contains('cart-drawer__wishlist-cta--in-empty');
      var visible = show;
      if (isEmpty && !inEmptyOnly) visible = false;
      if (!isEmpty && inEmptyOnly) visible = false;
      btn.hidden = !visible;
      btn.setAttribute('aria-hidden', visible ? 'false' : 'true');
    });
  }

  function getBulkAddCartItems() {
    var seen = {};
    var items = [];
    getWishlistProductRows().forEach(function (product) {
      if (!product || !product.variantId || product.available === false) return;
      if (isVariantInCart(product.variantId)) return;
      var vid = normalizeVariantIdForCart(product.variantId);
      if (!vid || seen[vid]) return;
      seen[vid] = true;
      var n = Number(vid);
      if (!Number.isFinite(n)) return;
      items.push({ id: n, quantity: 1 });
    });
    return items;
  }

  function shouldShowWishlistClearAll() {
    if (!state.ids.length) return false;
    var rows = getWishlistProductRows();
    if (rows.length < state.ids.length) return false;
    return getBulkAddCartItems().length === 0;
  }

  function updateWishlistClearAllButtons() {
    var show = shouldShowWishlistClearAll();
    document.querySelectorAll('[data-omx-wishlist-clear-all]').forEach(function (btn) {
      btn.hidden = !show;
      btn.setAttribute('aria-hidden', show ? 'false' : 'true');
    });
  }

  function updateBulkAddAllButtons() {
    var items = getBulkAddCartItems();
    var n = items.length;
    var drawer = document.querySelector('[data-omx-wishlist-drawer]');
    var footer = drawer && drawer.querySelector('.omx-wishlist-drawer__footer');
    if (footer) {
      footer.hidden = state.ids.length === 0;
    }
    document.querySelectorAll('[data-omx-wishlist-add-all]').forEach(function (btn) {
      if (!n) {
        btn.hidden = true;
        btn.setAttribute('aria-hidden', 'true');
        return;
      }
      btn.hidden = false;
      btn.setAttribute('aria-hidden', 'false');
      var label =
        n === 1
          ? 'Alle verfügbaren in den Warenkorb (1 Artikel)'
          : 'Alle verfügbaren in den Warenkorb (' + n + ' Artikel)';
      btn.setAttribute('aria-label', label);
    });
    updateWishlistClearAllButtons();
  }

  function addAllWishlistToCart(trigger) {
    var items = getBulkAddCartItems();
    if (!items.length) return Promise.resolve();

    var cart =
      document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    function finishWishlistAfterBulkCartAdd() {
      render();
      closeDrawer();
    }

    if (cart && typeof cart.getSectionsToRender === 'function' && typeof cart.renderContents === 'function') {
      var sectionIds = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      var body = {
        items: items,
        sections: sectionIds.join(','),
        sections_url: window.location.pathname
      };

      return fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript'
        },
        body: JSON.stringify(body)
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response.status) {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'wishlist-bulk',
                errors: response.errors || response.description,
                message: response.message
              });
            }
            console.warn('[Wishlist] Bulk cart add error', response.description || response.message);
            showDrawerNotice(
              response.message || response.description || 'Die Artikel konnten nicht hinzugefügt werden.'
            );
            return;
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'wishlist-bulk',
              cartData: response
            });
          }

          if (typeof cart.setActiveElement === 'function') {
            cart.setActiveElement(trigger && trigger instanceof Element ? trigger : document.activeElement);
          }
          cart.renderContents(response);
          if (cart.classList && cart.classList.contains('is-empty')) {
            cart.classList.remove('is-empty');
          }

          /* add.js ohne sections liefert oft nur die neuen Zeilen; mit sections meist vollständiger Warenkorb (token). */
          if (response.token && response.items) {
            applyCartItemsFromPayload(response);
            finishWishlistAfterBulkCartAdd();
          } else {
            syncCartVariantIdsFromNetwork().finally(finishWishlistAfterBulkCartAdd);
          }
        })
        .catch(function (error) {
          console.warn('[Wishlist] Bulk cart add failed', error);
        });
    }

    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart add failed');
        return response.json();
      })
      .then(function () {
        window.location.href = window.routes.cart_url;
      })
      .catch(function (error) {
        console.warn('[Wishlist] Bulk cart add failed', error);
      });
  }

  function storefrontProductQuery() {
    return [
      'query WishlistProducts($ids: [ID!]!) {',
      '  nodes(ids: $ids) {',
      '    ... on Product {',
      '      id',
      '      handle',
      '      title',
      '      onlineStoreUrl',
      '      featuredImage { url(transform: { maxWidth: 500 }) altText }',
      '      priceRange { minVariantPrice { amount currencyCode } }',
      '      variants(first: 1) { nodes { id title availableForSale } }',
      '      collections(first: 30) { nodes { handle } }',
      '    }',
      '  }',
      '}'
    ].join('\n');
  }

  function formatStorefrontProduct(node) {
    if (!node || !node.id) return null;
    var variant = node.variants && node.variants.nodes && node.variants.nodes[0];
    var price = node.priceRange && node.priceRange.minVariantPrice;
    var amount = price ? Number(price.amount) : null;
    var formattedPrice = amount == null
      ? ''
      : new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
          style: 'currency',
          currency: price.currencyCode || state.config.currency || 'EUR'
        }).format(amount);
    var collectionHandles = (node.collections && node.collections.nodes || [])
      .map(function (c) {
        return c && c.handle;
      })
      .filter(Boolean);

    return normalizeProduct({
      id: node.id,
      handle: node.handle,
      title: node.title,
      url: node.onlineStoreUrl || ('/products/' + node.handle),
      image: node.featuredImage && node.featuredImage.url,
      price: formattedPrice,
      variantId: variant && variant.id,
      variantTitle: variant && variant.title,
      available: variant ? variant.availableForSale : true,
      collectionHandles: collectionHandles,
      omxWishlistCollectionsFromApi: true
    });
  }

  function fetchMissingProducts() {
    var token = state.config.storefrontAccessToken;
    if (!token) return;

    var needCollections = getExcludeWishlistCollectionHandles().length > 0;
    var missing = state.ids.filter(function (id) {
      if (!state.products[id]) return true;
      if (!needCollections) return false;
      var p = state.products[id];
      if (p.excludedFromWishlist === true) return false;
      return p.omxWishlistCollectionsFromApi !== true;
    });
    if (!missing.length) return;

    fetch('/api/2024-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token
      },
      body: JSON.stringify({
        query: storefrontProductQuery(),
        variables: {
          ids: missing.map(function (id) {
            return 'gid://shopify/Product/' + id;
          })
        }
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Storefront product fetch failed');
        return response.json();
      })
      .then(function (payload) {
        (payload.data && payload.data.nodes || []).forEach(function (node) {
          var product = formatStorefrontProduct(node);
          if (product) state.products[product.id] = product;
        });
        persist();
        stripExcludedWishlistProducts();
        render();
      })
      .catch(function (error) {
        console.warn('[Wishlist] Storefront product fetch failed', error);
      });
  }

  function customerAccountConfig() {
    var account = state.config.customerAccount || {};
    var shopDomain = state.config.shopDomain || window.location.hostname;

    return {
      enabled: !!(account.clientId && account.authorizationEndpoint && account.tokenEndpoint),
      clientId: account.clientId || '',
      authorizationEndpoint: account.authorizationEndpoint || '',
      tokenEndpoint: account.tokenEndpoint || '',
      graphqlEndpoint: account.graphqlEndpoint || ('https://' + shopDomain + '/.well-known/customer-account-api'),
      redirectUri: account.redirectUri || (window.location.origin + '/pages/wishlist')
    };
  }

  function appProxyPath() {
    return state.config.appProxyPath || '';
  }

  function appProxyRequest(method, payload) {
    var path = appProxyPath();
    if (!path) return Promise.reject(new Error('Wishlist app proxy is not configured'));

    return fetch(path, {
      method: method,
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: payload ? JSON.stringify(payload) : undefined
    })
      .then(function (response) {
        if (response.status === 401 || response.status === 403) {
          state.customerSyncReady = false;
        }
        if (!response.ok) throw new Error('Wishlist app proxy request failed');
        return response.json();
      });
  }

  function syncAppProxyWishlist() {
    if (!appProxyPath() || !state.config.customerLoggedIn || state.syncInFlight) return Promise.resolve(false);

    state.syncInFlight = true;

    return appProxyRequest('GET')
      .then(function (payload) {
        var customerIds = unique(payload.ids || []);
        var localIds = unique(readJson(STORAGE_KEY, []));
        var mergedIds = unique(customerIds.concat(localIds).concat(state.ids));

        state.customerId = payload.customerId || '';
        state.customerSyncReady = !!state.customerId;
        state.ids = mergedIds;

        persist();
        render();
        fetchMissingProducts();

        if (state.config.customerLoggedIn && mergedIds.join(',') !== customerIds.join(',')) {
          return saveAppProxyWishlist();
        }

        return true;
      })
      .catch(function (error) {
        console.warn('[Wishlist] App proxy wishlist sync failed', error);
        return false;
      })
      .finally(function () {
        state.syncInFlight = false;
      });
  }

  function saveAppProxyWishlist() {
    if (!appProxyPath() || !state.config.customerLoggedIn) return Promise.resolve(false);

    var meta = readMetadata();
    var items = unique(state.ids).map(function(id) {
      var itemMeta = meta[id] || {};
      return {
        product_id: 'gid://shopify/Product/' + id,
        added_at:     itemMeta.added_at     || new Date().toISOString(),
        price_at_add: itemMeta.price_at_add || null
      };
    });

    return appProxyRequest('POST', {
      ids:   unique(state.ids),
      items: items
    })
      .then(function () {
        return true;
      })
      .catch(function (error) {
        console.warn('[Wishlist] App proxy wishlist save failed', error);
        return false;
      });
  }

  function saveRemoteWishlist() {
    if (appProxyPath()) return saveAppProxyWishlist();
    return saveCustomerAccountWishlist();
  }

  function base64Url(buffer) {
    var bytes = new Uint8Array(buffer);
    var binary = '';

    bytes.forEach(function (byte) {
      binary += String.fromCharCode(byte);
    });

    return window.btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  function randomString(length) {
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    var values = new Uint8Array(length);
    window.crypto.getRandomValues(values);

    return Array.from(values).map(function (value) {
      return chars[value % chars.length];
    }).join('');
  }

  function sha256(value) {
    return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(value));
  }

  function startCustomerAccountAuth(returnTo) {
    var account = customerAccountConfig();
    if (!account.enabled || !window.crypto || !window.crypto.subtle) {
      console.warn('[Wishlist] Customer Account API is not configured.');
      return Promise.resolve(false);
    }

    var verifier = randomString(96);
    var authState = randomString(32);

    return sha256(verifier).then(function (digest) {
      writeSessionJson(CUSTOMER_PKCE_KEY, {
        verifier: verifier,
        state: authState,
        returnTo: returnTo || window.location.href
      });

      var url = new URL(account.authorizationEndpoint);
      url.searchParams.set('client_id', account.clientId);
      url.searchParams.set('response_type', 'code');
      url.searchParams.set('redirect_uri', account.redirectUri);
      url.searchParams.set('scope', 'openid email customer-account-api:full');
      url.searchParams.set('state', authState);
      url.searchParams.set('code_challenge', base64Url(digest));
      url.searchParams.set('code_challenge_method', 'S256');

      window.location.assign(url.toString());
      return true;
    });
  }

  function handleCustomerAccountCallback() {
    var params = new URLSearchParams(window.location.search);
    var code = params.get('code');
    var returnedState = params.get('state');
    var pkce = readSessionJson(CUSTOMER_PKCE_KEY, null);
    var account = customerAccountConfig();

    if (!code || !returnedState || !pkce) return Promise.resolve(false);

    if (returnedState !== pkce.state) {
      removeSession(CUSTOMER_PKCE_KEY);
      console.warn('[Wishlist] Customer Account API state mismatch.');
      return Promise.resolve(false);
    }

    return fetch(account.tokenEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'application/json'
      },
      body: new URLSearchParams({
        grant_type: 'authorization_code',
        client_id: account.clientId,
        redirect_uri: account.redirectUri,
        code: code,
        code_verifier: pkce.verifier
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Customer Account token exchange failed');
        return response.json();
      })
      .then(function (payload) {
        writeCustomerToken(payload.access_token, payload.expires_in);
        removeSession(CUSTOMER_PKCE_KEY);
        cleanAuthParams();
        return syncCustomerAccountWishlist().then(function () {
          return true;
        });
      })
      .catch(function (error) {
        console.warn('[Wishlist] Customer Account callback failed', error);
        removeSession(CUSTOMER_PKCE_KEY);
        cleanAuthParams();
        return false;
      });
  }

  function cleanAuthParams() {
    var url = new URL(window.location.href);
    url.searchParams.delete('code');
    url.searchParams.delete('state');
    url.searchParams.delete('iss');
    url.searchParams.delete('locale');
    window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
  }

  function resolveCustomerGraphqlEndpoint() {
    var account = customerAccountConfig();

    if (account.graphqlEndpoint.indexOf('/graphql') !== -1) {
      return Promise.resolve(account.graphqlEndpoint);
    }

    return fetch(account.graphqlEndpoint)
      .then(function (response) {
        if (!response.ok) throw new Error('Customer Account API discovery failed');
        return response.json();
      })
      .then(function (payload) {
        return payload.graphql_api || payload.graphqlApi || payload.customer_account_api || account.graphqlEndpoint;
      });
  }

  function customerAccountRequest(query, variables) {
    var token = readCustomerToken();
    if (!token) return Promise.reject(new Error('Missing Customer Account API token'));

    return resolveCustomerGraphqlEndpoint().then(function (endpoint) {
      return fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': token
        },
        body: JSON.stringify({
          query: query,
          variables: variables || {}
        })
      });
    })
      .then(function (response) {
        if (response.status === 401 || response.status === 403) {
          clearCustomerToken();
        }
        if (!response.ok) throw new Error('Customer Account API request failed');
        return response.json();
      })
      .then(function (payload) {
        if (payload.errors && payload.errors.length) {
          throw new Error(payload.errors.map(function (error) { return error.message; }).join(', '));
        }
        return payload.data;
      });
  }

  function customerWishlistQuery() {
    return [
      'query OmxCustomerWishlist {',
      '  customer {',
      '    id',
      '    metafield(namespace: "custom", key: "wishlist") {',
      '      value',
      '      references(first: 100) {',
      '        nodes {',
      '          ... on Product {',
      '            id',
      '            handle',
      '            title',
      '            onlineStoreUrl',
      '            featuredImage { url(transform: { maxWidth: 500 }) altText }',
      '            priceRange { minVariantPrice { amount currencyCode } }',
      '            variants(first: 1) { nodes { id title availableForSale } }',
      '          }',
      '        }',
      '      }',
      '    }',
      '  }',
      '}'
    ].join('\n');
  }

  function customerWishlistMutation() {
    return [
      'mutation OmxCustomerWishlistSet($metafields: [MetafieldsSetInput!]!) {',
      '  metafieldsSet(metafields: $metafields) {',
      '    metafields { key namespace value }',
      '    userErrors { field message code }',
      '  }',
      '}'
    ].join('\n');
  }

  function idsFromMetafieldValue(value) {
    if (!value) return [];

    try {
      return unique(JSON.parse(value));
    } catch (error) {
      return [];
    }
  }

  function syncCustomerAccountWishlist() {
    if (state.syncInFlight || !readCustomerToken()) return Promise.resolve(false);

    state.syncInFlight = true;

    return customerAccountRequest(customerWishlistQuery())
      .then(function (data) {
        var customer = data && data.customer;
        var metafield = customer && customer.metafield;
        var customerIds = idsFromMetafieldValue(metafield && metafield.value);
        var localIds = unique(readJson(STORAGE_KEY, []));
        var mergedIds = unique(customerIds.concat(localIds).concat(state.ids));

        state.customerId = customer && customer.id;
        state.customerSyncReady = !!state.customerId;
        state.ids = mergedIds;

        ((metafield && metafield.references && metafield.references.nodes) || []).forEach(function (node) {
          var product = formatStorefrontProduct(node);
          if (product) state.products[product.id] = product;
        });

        persist();
        render();
        fetchMissingProducts();

        if (state.customerId && mergedIds.join(',') !== customerIds.join(',')) {
          return saveCustomerAccountWishlist();
        }

        return true;
      })
      .catch(function (error) {
        console.warn('[Wishlist] Customer Account wishlist sync failed', error);
        return false;
      })
      .finally(function () {
        state.syncInFlight = false;
      });
  }

  function saveCustomerAccountWishlist() {
    if (!readCustomerToken() || !state.customerId) return Promise.resolve(false);

    var gidIds = unique(state.ids).map(function (id) {
      return 'gid://shopify/Product/' + id;
    });

    return customerAccountRequest(customerWishlistMutation(), {
      metafields: [
        {
          ownerId: state.customerId,
          namespace: 'custom',
          key: 'wishlist',
          type: 'list.product_reference',
          value: JSON.stringify(gidIds)
        }
      ]
    })
      .then(function (data) {
        var errors = data && data.metafieldsSet && data.metafieldsSet.userErrors;
        if (errors && errors.length) {
          throw new Error(errors.map(function (error) { return error.message; }).join(', '));
        }
        return true;
      })
      .catch(function (error) {
        console.warn('[Wishlist] Customer Account wishlist save failed', error);
        return false;
      });
  }

  function bindEvents() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-omx-wishlist-button]');
      if (button) {
        event.preventDefault();
        toggle(button);
        return;
      }

      if (event.target.closest('[data-omx-wishlist-open]')) {
        event.preventDefault();
        var cartDrawerEl = document.querySelector('cart-drawer');
        if (cartDrawerEl && typeof cartDrawerEl.close === 'function') {
          cartDrawerEl.close();
        }
        if (!appProxyPath() && customerAccountConfig().enabled && !readCustomerToken()) {
          startCustomerAccountAuth(window.location.href);
          return;
        }
        openDrawer();
        if (appProxyPath() && state.config.customerLoggedIn) {
          syncAppProxyWishlist();
        } else if (!appProxyPath()) {
          syncCustomerAccountWishlist();
        }
        fetchMissingProducts();
        return;
      }

      if (event.target.closest('[data-omx-wishlist-connect]')) {
        event.preventDefault();
        if (appProxyPath()) {
          if (!state.config.customerLoggedIn) {
            openLoginDrawer();
            return;
          }
          syncAppProxyWishlist();
          return;
        }
        startCustomerAccountAuth(window.location.href);
        return;
      }

      if (event.target.closest('[data-omx-wishlist-close]')) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      if (event.target.matches('[data-omx-wishlist-overlay]')) {
        event.preventDefault();
        if (state.isLoginOpen) closeLoginDrawer();
        else closeDrawer();
        return;
      }

      if (event.target.closest('[data-omx-wishlist-login-open]')) {
        event.preventDefault();
        openLoginDrawer();
        return;
      }

      if (event.target.closest('[data-omx-wishlist-login-close]')) {
        event.preventDefault();
        closeLoginDrawer();
        return;
      }

      if (
        event.target.matches('[data-omx-wishlist-panel-backdrop]') ||
        event.target.matches('[data-omx-wishlist-login-stack-overlay]')
      ) {
        event.preventDefault();
        closeLoginDrawer();
        return;
      }

      var removeButton = event.target.closest('[data-omx-wishlist-remove]');
      if (removeButton) {
        event.preventDefault();
        remove(removeButton.getAttribute('data-omx-wishlist-remove'));
        return;
      }

      var cartButton = event.target.closest('[data-omx-wishlist-cart]');
      if (cartButton) {
        event.preventDefault();
        addToCart(cartButton.getAttribute('data-omx-wishlist-cart'));
        return;
      }

      var addAllBtn = event.target.closest('[data-omx-wishlist-add-all]');
      if (addAllBtn) {
        if (addAllBtn.getAttribute('aria-disabled') === 'true') return;
        event.preventDefault();
        addAllBtn.setAttribute('aria-disabled', 'true');
        addAllBtn.classList.add('loading');
        addAllWishlistToCart(addAllBtn).finally(function () {
          addAllBtn.classList.remove('loading');
          addAllBtn.removeAttribute('aria-disabled');
          updateBulkAddAllButtons();
        });
        return;
      }

      if (event.target.closest('[data-omx-wishlist-clear-all]')) {
        event.preventDefault();
        clearEntireWishlist();
        return;
      }
    });

    document.addEventListener('submit', function (event) {
      if (!event.target.matches('[data-omx-wishlist-login-form]')) return;

      try {
        window.sessionStorage.setItem(PENDING_CLASSIC_LOGIN_KEY, '1');
        writeSession(WISHLIST_AUTH_FORM_KEY, event.target.getAttribute('data-omx-wishlist-auth-form') || '');
      } catch (error) {
        console.warn('[Wishlist] Could not persist pending login flag', error);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !state.isOpen) return;
      if (state.isLoginOpen) {
        closeLoginDrawer();
      } else {
        closeDrawer();
      }
    });

    window.addEventListener('resize', syncWishlistLoginLayer);
    try {
      window.matchMedia('(max-width: 749px)').addEventListener('change', syncWishlistLoginLayer);
    } catch (err) {
      window.matchMedia('(max-width: 749px)').addListener(syncWishlistLoginLayer);
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cartData && Array.isArray(event.cartData.items)) {
          applyCartItemsFromPayload(event.cartData);
          render();
        } else {
          syncCartVariantIdsFromNetwork().finally(function () {
            render();
          });
        }
      });
    }

    document.addEventListener(
      'click',
      function (event) {
        var t = event.target && event.target.closest('[data-omx-wishlist-drawer-cart]');
        if (!t) return;
        if (state.isOpen) closeDrawer();
      },
      true
    );
  }

  function consumeClassicLoginReturn() {
    var params = new URLSearchParams(window.location.search);
    var cameFromWishlistLogin = params.get('wishlist_login') === '1';
    var hadPendingLogin = false;

    try {
      hadPendingLogin = window.sessionStorage.getItem(PENDING_CLASSIC_LOGIN_KEY) === '1';
      window.sessionStorage.removeItem(PENDING_CLASSIC_LOGIN_KEY);
    } catch (error) {
      hadPendingLogin = false;
    }

    if (cameFromWishlistLogin) {
      var cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete('wishlist_login');
      window.history.replaceState({}, document.title, cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
    }

    if (!cameFromWishlistLogin && !hadPendingLogin) return;

    state.isOpen = true;
    state.isLoginOpen = !state.config.customerLoggedIn;
    render();

    if (state.config.customerLoggedIn) {
      showDrawerNotice('Du bist angemeldet. Deine Wishlist wird jetzt in deinem Kundenkonto gespeichert.');
      announce('Wishlist wurde mit deinem Kundenkonto verbunden.');
    } else {
      showDrawerNotice('Bitte melde dich an, um deine Wishlist zu speichern.');
      openLoginDrawer();
    }
  }

  function init() {
    loadState();
    bindEvents();
    observeHeaderCartBubbleForWishlistDrawer();
    syncWishlistDrawerCartIconFromHeader();
    render();
    syncCartVariantIdsFromNetwork().finally(function () {
      render();
    });
    fetchMissingProducts();
    consumeClassicLoginReturn();
    renderWishlistAuthErrors();

    if (appProxyPath()) {
      if (!state.config.customerLoggedIn) return;
      state.customerSyncReady = true;
      syncAppProxyWishlist();
      return;
    }

    handleCustomerAccountCallback().then(function (handled) {
      if (!handled && readCustomerToken()) {
        syncCustomerAccountWishlist();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
